const Link = {
  sx: {
    cursor: 'pointer'
  }
};
export default {
  Link
};
